import { render } from "./BasicForm.vue?vue&type=template&id=36e10318&scoped=true"
import script from "./BasicForm.vue?vue&type=script&lang=ts"
export * from "./BasicForm.vue?vue&type=script&lang=ts"

import "./BasicForm.vue?vue&type=style&index=0&id=36e10318&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36e10318"

export default script